export const searchParams = new URLSearchParams(window.location.search);
